import parseISO from 'date-fns/parseISO';

import { DateString } from 'components/Datepicker/types';

function parseDateString(date: DateString): Date {
    return typeof date === 'string' ? parseISO(date) : date;
}

export default parseDateString;
